module.exports = __webpack_public_path__ + "static/g-7-78f2ba0f485ca4a2c55b364aa0cba032.jpg";